
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
// ============================================================
// 滚动显现：IntersectionObserver 驱动 .load-hidden
// （替代原 scrollreveal CDN，零外部依赖）
// ============================================================
function $6f019d1f45ba2738$export$2e2bcd8739ae039() {
    const items = document.querySelectorAll(".load-hidden, [data-reveal]");
    if (!items.length) return;
    if (!("IntersectionObserver" in window)) {
        items.forEach((el)=>el.classList.add("is-visible"));
        return;
    }
    const io = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting) {
                entry.target.classList.add("is-visible");
                io.unobserve(entry.target);
            }
        });
    }, {
        threshold: 0.12,
        rootMargin: "0px 0px -36px 0px"
    });
    items.forEach((el)=>io.observe(el));
}


// ============================================================
// 开机启动序列：JKDY/OS 引导动画（可点击/按键跳过）
// ============================================================
const $1585118342945ec6$var$BOOT_LINES = [
    {
        text: "JKDY/OS v2.6.6 \u2014 \u6781\u5BA2\u5BFC\u6F14\u521B\u610F\u7CFB\u7EDF",
        cls: "dim"
    },
    {
        text: "> \u6302\u8F7D\u795E\u7ECF\u7F51\u7EDC\u6E32\u67D3\u5668 .......... OK",
        cls: "ok"
    },
    {
        text: "> \u542F\u52A8 GPU \u96C6\u7FA4 (8\xd7 RTX \u6A21\u62DF) .. OK",
        cls: "ok"
    },
    {
        text: "> \u89E3\u7801 imagination \u6A21\u5757 ........ OK",
        cls: "ok"
    },
    {
        text: "> \u6CE8\u5165\u521B\u4F5C\u57FA\u56E0 ................ OK",
        cls: "ok"
    },
    {
        text: "> ACCESS GRANTED \u2014 \u6B22\u8FCE\u56DE\u6765\uFF0C\u5BFC\u6F14",
        cls: "ok"
    }
];
const $1585118342945ec6$var$BOOT_MS = 1500; // 默认启动时长
function $1585118342945ec6$export$2e2bcd8739ae039() {
    const overlay = document.getElementById("boot");
    if (!overlay) return;
    const linesEl = document.getElementById("boot-lines");
    const barEl = document.getElementById("boot-progress-bar");
    let finished = false;
    const finish = ()=>{
        if (finished) return;
        finished = true;
        overlay.classList.add("is-done");
        window.dispatchEvent(new CustomEvent("jk:booted"));
        // 过渡结束后移出 DOM，避免遮挡交互
        setTimeout(()=>overlay.remove(), 600);
        document.removeEventListener("keydown", skip);
        overlay.removeEventListener("click", skip);
    };
    const skip = ()=>finish();
    document.addEventListener("keydown", skip);
    overlay.addEventListener("click", skip);
    // 逐行输出
    let i = 0;
    const typeLine = ()=>{
        if (finished || i >= $1585118342945ec6$var$BOOT_LINES.length) return;
        const line = $1585118342945ec6$var$BOOT_LINES[i];
        const p = document.createElement("p");
        p.className = line.cls;
        p.textContent = line.text;
        linesEl.appendChild(p);
        i += 1;
        setTimeout(typeLine, 170);
    };
    typeLine();
    // 进度条
    const startAt = performance.now();
    const tick = (now)=>{
        if (finished) return;
        const p = Math.min((now - startAt) / $1585118342945ec6$var$BOOT_MS, 1);
        barEl.style.width = `${Math.round(p * 100)}%`;
        if (p < 1) requestAnimationFrame(tick);
        else finish();
    };
    requestAnimationFrame(tick);
    // 兜底：任何环境下（含 rAF 被限制的无头渲染）都能按时完成启动
    setTimeout(finish, $1585118342945ec6$var$BOOT_MS + 600);
}


// ============================================================
// 导航：滚动状态 + 实时时钟 + 移动端菜单 + 滚动高亮
// ============================================================
const $97a50dd4078512d4$var$SECTION_IDS = [
    "home",
    "works",
    "about",
    "contact"
];
function $97a50dd4078512d4$export$2e2bcd8739ae039() {
    const nav = document.getElementById("nav");
    const toggle = document.getElementById("nav-toggle");
    const menu = document.getElementById("mobile-menu");
    const clock = document.getElementById("nav-clock");
    if (!nav || !toggle || !menu) return;
    // 滚动状态 + Scrollspy
    const onScroll = ()=>{
        nav.classList.toggle("is-scrolled", window.scrollY > 10);
        let current = "home";
        $97a50dd4078512d4$var$SECTION_IDS.forEach((id)=>{
            const el = document.getElementById(id);
            if (el && el.getBoundingClientRect().top <= 140) current = id;
        });
        document.querySelectorAll(".nav-link, .mobile-menu a[data-nav]").forEach((a)=>{
            a.classList.toggle("is-active", a.dataset.nav === current);
        });
    };
    window.addEventListener("scroll", onScroll, {
        passive: true
    });
    onScroll();
    // 实时时钟
    const updateClock = ()=>{
        if (!clock) return;
        const d = new Date();
        const pad = (n)=>String(n).padStart(2, "0");
        clock.textContent = `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
    };
    updateClock();
    setInterval(updateClock, 1000);
    // 移动端菜单
    const closeMenu = ()=>{
        toggle.classList.remove("is-open");
        menu.classList.remove("is-open");
        toggle.setAttribute("aria-expanded", "false");
        menu.setAttribute("aria-hidden", "true");
    };
    toggle.addEventListener("click", ()=>{
        const isOpen = menu.classList.toggle("is-open");
        toggle.classList.toggle("is-open", isOpen);
        toggle.setAttribute("aria-expanded", String(isOpen));
        menu.setAttribute("aria-hidden", String(!isOpen));
    });
    menu.querySelectorAll("a").forEach((a)=>a.addEventListener("click", closeMenu));
    window.addEventListener("resize", ()=>{
        if (window.innerWidth > 768) closeMenu();
    });
}


// ============================================================
// 矩阵雨：Hero 背景 Canvas（支持 off / normal / overdrive 模式）
// ============================================================
const $2a50b2c290a652fc$var$CHARS = "01JKDYAI\u6781\u5BA2\u5BFC\u6F14\u89C6\u9891\u56FE\u50CF\u97F3\u4E50$#%&<>[]{}*+=/\\|_~^;:,.?!";
const $2a50b2c290a652fc$var$MODE_STYLE = {
    off: {
        opacity: 0,
        speed: 0
    },
    normal: {
        opacity: 0.5,
        speed: 1
    },
    overdrive: {
        opacity: 0.95,
        speed: 2.6
    }
};
const $2a50b2c290a652fc$var$OVERDRIVE_MS = 8000; // 超频模式自动回落时长
function $2a50b2c290a652fc$export$2e2bcd8739ae039() {
    const canvas = document.getElementById("matrix-canvas");
    if (!canvas) return null;
    const ctx = canvas.getContext("2d");
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    let cols = 0;
    let drops = [];
    let fontSize = 16;
    let raf = 0;
    let last = 0;
    let speed = $2a50b2c290a652fc$var$MODE_STYLE.normal.speed;
    let overdriveTimer = null;
    const resize = ()=>{
        const dpr = Math.min(window.devicePixelRatio || 1, 2);
        const w = canvas.clientWidth;
        const h = canvas.clientHeight;
        canvas.width = Math.floor(w * dpr);
        canvas.height = Math.floor(h * dpr);
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        fontSize = w < 640 ? 14 : 16;
        cols = Math.ceil(w / fontSize);
        drops = Array.from({
            length: cols
        }, ()=>Math.floor(Math.random() * -40));
    };
    const draw = (now)=>{
        raf = requestAnimationFrame(draw);
        if (speed === 0 || reduced) return;
        if (now - last < 33) return; // 约 30fps 限流，控制开销
        last = now;
        ctx.fillStyle = "rgba(4, 7, 13, 0.09)";
        ctx.fillRect(0, 0, canvas.clientWidth, canvas.clientHeight);
        ctx.font = `${fontSize}px Consolas, monospace`;
        for(let i = 0; i < cols; i++){
            const ch = $2a50b2c290a652fc$var$CHARS[Math.floor(Math.random() * $2a50b2c290a652fc$var$CHARS.length)];
            const bright = Math.random() > 0.975;
            ctx.fillStyle = bright ? "#e8f4ff" : Math.random() > 0.5 ? "#00ff9c" : "#00b371";
            ctx.fillText(ch, i * fontSize, drops[i] * fontSize);
            if (drops[i] * fontSize > canvas.clientHeight && Math.random() > 0.975) drops[i] = Math.floor(Math.random() * -20);
            drops[i] += 1 * speed;
        }
    };
    const setMode = (mode)=>{
        const style = $2a50b2c290a652fc$var$MODE_STYLE[mode] || $2a50b2c290a652fc$var$MODE_STYLE.normal;
        canvas.style.opacity = String(style.opacity);
        speed = style.speed;
        if (mode === "overdrive") {
            clearTimeout(overdriveTimer);
            overdriveTimer = setTimeout(()=>setMode("normal"), $2a50b2c290a652fc$var$OVERDRIVE_MS);
        }
    };
    resize();
    window.addEventListener("resize", resize);
    document.addEventListener("visibilitychange", ()=>{
        if (document.hidden) {
            cancelAnimationFrame(raf);
            raf = 0;
        } else if (!raf) raf = requestAnimationFrame(draw);
    });
    raf = requestAnimationFrame(draw);
    setMode("normal");
    return {
        setMode: setMode
    };
}


// ============================================================
// 打字机循环：Hero 提示语（开机完成后启动）
// ============================================================
const $e39186f59ac2e9a5$var$LINES = [
    "\u6B63\u5728\u6E32\u67D3\uFF1A\u5C5E\u4E8E\u4F60\u7684 AI \u7535\u5F71\u2026",
    "\u6B63\u5728\u751F\u6210\uFF1A8K \u9AD8\u6E05 AI \u56FE\u50CF\u2026",
    "\u6B63\u5728\u4F5C\u66F2\uFF1A\u8D5B\u535A\u7535\u5B50 \xd7 \u4E1C\u65B9\u97F5\u5F8B\u2026",
    "\u5C31\u7EEA\u3002\u5BFC\u6F14\uFF0C\u8BF7\u4E0B\u4EE4\u3002"
];
const $e39186f59ac2e9a5$var$TYPE_MS = 68;
const $e39186f59ac2e9a5$var$HOLD_MS = 1400;
const $e39186f59ac2e9a5$var$DELETE_MS = 26;
const $e39186f59ac2e9a5$var$START_DELAY = 250;
function $e39186f59ac2e9a5$export$2e2bcd8739ae039() {
    const el = document.getElementById("hero-typed");
    if (!el) return;
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduced) {
        el.textContent = $e39186f59ac2e9a5$var$LINES[0];
        return;
    }
    let lineIndex = 0;
    let charIndex = 0;
    let deleting = false;
    let timer = null;
    const step = ()=>{
        const line = $e39186f59ac2e9a5$var$LINES[lineIndex];
        if (!deleting) {
            charIndex += 1;
            el.textContent = line.slice(0, charIndex);
            if (charIndex === line.length) {
                deleting = true;
                timer = setTimeout(step, $e39186f59ac2e9a5$var$HOLD_MS);
                return;
            }
            timer = setTimeout(step, $e39186f59ac2e9a5$var$TYPE_MS);
        } else {
            charIndex -= 1;
            el.textContent = line.slice(0, charIndex);
            if (charIndex === 0) {
                deleting = false;
                lineIndex = (lineIndex + 1) % $e39186f59ac2e9a5$var$LINES.length;
            }
            timer = setTimeout(step, $e39186f59ac2e9a5$var$DELETE_MS);
        }
    };
    const start = ()=>{
        clearTimeout(timer);
        setTimeout(step, $e39186f59ac2e9a5$var$START_DELAY);
    };
    // 等待开机序列结束（容错：若事件缺失，兜底启动）
    let booted = false;
    window.addEventListener("jk:booted", ()=>{
        if (!booted) {
            booted = true;
            start();
        }
    });
    setTimeout(()=>{
        if (!booted) {
            booted = true;
            start();
        }
    }, 4200);
}


// ============================================================
// 数据动画：Hero 计数、技能条填充、whoami ASCII 注入
// ============================================================
// JKDY 标准 5x7 像素字体（█ 单块点阵）
// 说明：K 的斜腿交叉需要 5 列像素才能正确表达，4 列(██ 双块)会渲染成 U，故采用 5 列像素方案
const $19a012ebf879b934$var$ASCII_ART = [
    "\u2588\u2588\u2588\u2588\u2588 \u2588\xb7\xb7\xb7\u2588 \u2588\u2588\u2588\u2588\xb7 \u2588\xb7\xb7\xb7\u2588",
    "\xb7\xb7\xb7\u2588\xb7 \u2588\xb7\xb7\u2588\xb7 \u2588\xb7\xb7\u2588\xb7 \xb7\u2588\xb7\u2588\xb7",
    "\xb7\xb7\xb7\u2588\xb7 \u2588\xb7\u2588\xb7\xb7 \u2588\xb7\xb7\u2588\xb7 \xb7\xb7\u2588\xb7\xb7",
    "\xb7\xb7\xb7\u2588\xb7 \u2588\u2588\u2588\xb7\xb7 \u2588\xb7\xb7\u2588\xb7 \xb7\xb7\u2588\xb7\xb7",
    "\xb7\xb7\xb7\u2588\xb7 \u2588\xb7\u2588\xb7\xb7 \u2588\xb7\xb7\u2588\xb7 \xb7\xb7\u2588\xb7\xb7",
    "\u2588\xb7\xb7\u2588\xb7 \u2588\xb7\xb7\u2588\xb7 \u2588\xb7\xb7\u2588\xb7 \xb7\xb7\u2588\xb7\xb7",
    "\xb7\u2588\u2588\xb7\xb7 \u2588\xb7\xb7\xb7\u2588 \u2588\u2588\u2588\u2588\xb7 \xb7\xb7\u2588\xb7\xb7"
].join("\n");
// ---------- 遥测模拟：GPU / FPS / LATENCY 动态监控 ----------
// 用「随机游走」模拟真实系统遥测读数：每次采样在上次基础上小幅增减，
// 并钳制在合理区间内，避免数值越界或突变过大，观感自然（类似真实监控曲线）。
const $19a012ebf879b934$var$MONITOR = [
    {
        selector: ".hero-stat:nth-child(1) .count",
        base: 87,
        min: 62,
        max: 96,
        step: 3,
        ms: 2000
    },
    {
        selector: ".hero-stat:nth-child(2) .count",
        base: 144,
        min: 118,
        max: 165,
        step: 4,
        ms: 1500
    },
    {
        selector: ".hero-stat:nth-child(3) .count",
        base: 9,
        min: 5,
        max: 22,
        step: 2,
        ms: 2500
    }
];
// 启动遥测刷新（在开机动画结束、计数动画完成后运行，避免相互覆盖）
function $19a012ebf879b934$var$initMonitor() {
    $19a012ebf879b934$var$MONITOR.forEach((m)=>{
        const el = document.querySelector(m.selector);
        if (!el) return;
        let v = m.base;
        el.textContent = v;
        setInterval(()=>{
            // 随机游走：±step 内随机偏移，并钳制在 [min, max]
            const delta = (Math.random() - 0.5) * 2 * m.step;
            v = Math.round(Math.min(m.max, Math.max(m.min, v + delta)));
            el.textContent = v;
        }, m.ms);
    });
}
function $19a012ebf879b934$export$2e2bcd8739ae039() {
    // whoami ASCII 注入
    const ascii = document.querySelector(".ascii-art");
    if (ascii) ascii.textContent = $19a012ebf879b934$var$ASCII_ART;
    // 开机完成后延迟启动遥测模拟（跳过 boot 覆盖屏，避免被遮挡）
    window.addEventListener("jk:booted", ()=>setTimeout($19a012ebf879b934$var$initMonitor, 1600), {
        once: true
    });
    const counts = document.querySelectorAll(".count[data-count]");
    const fills = document.querySelectorAll(".skill__fill[data-fill]");
    if (!counts.length && !fills.length) return;
    if (!("IntersectionObserver" in window)) {
        counts.forEach((el)=>{
            el.textContent = el.dataset.count;
        });
        fills.forEach((el)=>{
            el.style.width = `${el.dataset.fill}%`;
        });
        return;
    }
    const animateCount = (el)=>{
        const target = parseInt(el.dataset.count, 10) || 0;
        const dur = 1300;
        const t0 = performance.now();
        const step = (now)=>{
            const p = Math.min((now - t0) / dur, 1);
            const eased = 1 - Math.pow(1 - p, 3);
            el.textContent = Math.round(target * eased);
            if (p < 1) requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
    };
    const io = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            if (!entry.isIntersecting) return;
            entry.target.querySelectorAll(".count[data-count]").forEach(animateCount);
            entry.target.querySelectorAll(".skill__fill[data-fill]").forEach((el)=>{
                el.style.width = `${el.dataset.fill}%`;
            });
            io.unobserve(entry.target);
        });
    }, {
        threshold: 0.3
    });
    counts.forEach((el)=>{
        const scope = el.closest("[data-reveal]") || document.body;
        io.observe(scope === document.body ? el : scope);
    });
    fills.forEach((el)=>{
        const scope = el.closest("[data-reveal]") || el;
        io.observe(scope);
    });
}


// ============================================================
// 作品区交互：RUN 渲染模拟 + 画廊 + 灯箱
// ============================================================
const $946dd3a1a39b1629$var$RUN_PROFILES = {
    video: {
        total: 3000,
        log: (frame)=>`rendering frame ${String(frame).padStart(4, "0")}/3000`
    },
    image: {
        phases: [
            "sampling latent space \u2026",
            "refining details \u2026",
            "upscaling to 8K \u2026"
        ],
        log: null
    },
    music: {
        phases: [
            "composing bar 32 @ 128bpm \u2026",
            "mixing track 3/8 \u2026",
            "mastering waveform \u2026"
        ],
        log: null
    }
};
function $946dd3a1a39b1629$export$2e2bcd8739ae039() {
    // ---------- RUN 按钮 ----------
    document.querySelectorAll("[data-run]").forEach((btn)=>{
        btn.addEventListener("click", ()=>{
            const key = btn.dataset.run;
            const box = document.querySelector(`[data-runbox="${key}"]`);
            if (!box || btn.classList.contains("is-running")) return;
            const profile = $946dd3a1a39b1629$var$RUN_PROFILES[key];
            const bar = box.querySelector(".run-progress__bar");
            const logEl = box.querySelector(".run-log");
            const outEl = box.querySelector(".run-out");
            const gallery = box.querySelector(".run-gallery");
            const wave = box.querySelector(".run-wave");
            const hidden = [
                outEl,
                gallery,
                wave
            ].filter(Boolean);
            hidden.forEach((el)=>el.setAttribute("hidden", ""));
            box.hidden = false;
            btn.classList.add("is-running");
            btn.querySelector(".btn-jk__ic").textContent = "\u2026";
            const dur = key === "video" ? 1800 : 2200;
            const start = performance.now();
            const complete = ()=>{
                bar.style.width = "100%";
                if (profile.log) logEl.textContent = profile.log(profile.total);
                else if (profile.phases) logEl.textContent = profile.phases[profile.phases.length - 1];
                btn.classList.remove("is-running");
                btn.querySelector(".btn-jk__ic").textContent = "\u2713";
                if (outEl) outEl.hidden = false;
                if (gallery) gallery.hidden = false;
                if (wave) wave.hidden = false;
            };
            const step = (now)=>{
                const p = Math.min((now - start) / dur, 1);
                bar.style.width = `${Math.round(p * 100)}%`;
                if (profile.log) {
                    const frame = Math.min(profile.total, Math.round(p * profile.total));
                    logEl.textContent = profile.log(frame);
                } else if (profile.phases) {
                    const idx = Math.min(profile.phases.length - 1, Math.floor(p * profile.phases.length));
                    logEl.textContent = profile.phases[idx];
                }
                if (p < 1) requestAnimationFrame(step);
                else complete();
            };
            requestAnimationFrame(step);
            // 兜底：rAF 受限环境下也保证完成（与开机动画同策略）
            setTimeout(complete, dur + 400);
        });
    });
    // ---------- 灯箱 ----------
    const lightbox = document.getElementById("lightbox");
    if (!lightbox) return;
    const img = document.getElementById("lightbox-img");
    const caption = document.getElementById("lightbox-caption");
    const open = (src, cap)=>{
        img.src = src;
        img.alt = cap || "\u4F5C\u54C1";
        caption.textContent = cap || "";
        lightbox.classList.add("is-open");
        lightbox.setAttribute("aria-hidden", "false");
    };
    const close = ()=>{
        lightbox.classList.remove("is-open");
        lightbox.setAttribute("aria-hidden", "true");
    };
    document.querySelectorAll("[data-lightbox]").forEach((item)=>{
        item.addEventListener("click", ()=>{
            // 优先取按钮内 <img> 的 src（Parcel 构建后已重写为哈希路径）
            const imgEl = item.querySelector("img");
            const src = imgEl ? imgEl.src : item.dataset.lightbox;
            open(src, item.dataset.caption || "");
        });
    });
    lightbox.addEventListener("click", close);
    document.addEventListener("keydown", (e)=>{
        if (e.key === "Escape") close();
    });
}


// ============================================================
// 终端小部件：jkl@jkdy:~$ 命令引擎（右下 Dock）
// ============================================================
// ============================================================
// UI 共享工具：Toast 通知 + 全局故障特效
// ============================================================
function $bfc1bd9ef2af3f3a$export$f6cef6fcf9ca4e17(message, ms = 3200) {
    const host = document.getElementById("toast");
    if (!host) return;
    const el = document.createElement("div");
    el.className = "toast-item";
    el.textContent = message;
    host.appendChild(el);
    setTimeout(()=>{
        el.classList.add("is-leave");
        setTimeout(()=>el.remove(), 320);
    }, ms);
}
function $bfc1bd9ef2af3f3a$export$8cc04514940e4c06(ms = 2600) {
    document.body.classList.add("glitch-mode");
    setTimeout(()=>document.body.classList.remove("glitch-mode"), ms);
}
// ============================================================
// PANZER 彩蛋特效：页面震动 + 坦克 ASCII 覆盖层（居中闪现）
// 由键盘序列 panzer / 终端命令 panzer 触发
// ============================================================
const $bfc1bd9ef2af3f3a$var$TANK_ART = [
    "      \u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588",
    "     \u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588",
    "    \u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588",
    "   \u2588\u2588\u2588\u2588\u2588\u2588\u2584\u2584\u2584\u2584\u2588\u2588\u2588\u2588\u2588\u2588",
    "   \u2588\u2588\u2588\u2588\u2580\u2580\u2580\u2580\u2580\u2580\u2580\u2580\u2588\u2588\u2588\u2588",
    "   \u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588",
    "    \u2580\u2588\u2588\u2588\u2584\u2584\u2584\u2584\u2584\u2584\u2588\u2588\u2588\u2580",
    "      \u2588\u2588      \u2588\u2588",
    "     \u2588\u2588        \u2588\u2588",
    "    \u2588\u2588          \u2588\u2588",
    "   \u2588\u2588            \u2588\u2588"
].join("\n");
function $bfc1bd9ef2af3f3a$export$9e738c6099686bcf() {
    // 页面横向震动（400ms，模拟坦克落地的冲击）
    document.body.classList.add("tank-shake");
    setTimeout(()=>document.body.classList.remove("tank-shake"), 420);
    // 居中闪现坦克 ASCII 覆盖层（1.6s 后自动移除）
    const tank = document.createElement("pre");
    tank.className = "tank-ascii";
    tank.setAttribute("aria-hidden", "true");
    tank.textContent = $bfc1bd9ef2af3f3a$var$TANK_ART;
    document.body.appendChild(tank);
    setTimeout(()=>tank.remove(), 1700);
}


const $dd00c3b72143464c$var$HELP = [
    {
        cmd: "help",
        desc: "\u663E\u793A\u53EF\u7528\u6307\u4EE4"
    },
    {
        cmd: "whoami",
        desc: "\u770B\u770B\u8FD9\u4F4D\u5BFC\u6F14\u662F\u8C01"
    },
    {
        cmd: "date",
        desc: "\u663E\u793A\u5F53\u524D\u65F6\u95F4"
    },
    {
        cmd: "projects",
        desc: "\u5217\u51FA\u4EE3\u8868\u4F5C\u54C1"
    },
    {
        cmd: "matrix on / off",
        desc: "\u5F00\u5173\u77E9\u9635\u96E8"
    },
    {
        cmd: "glitch",
        desc: "\u89E6\u53D1\u4E00\u6B21\u5168\u5C40\u6545\u969C"
    },
    {
        cmd: "konami",
        desc: "\u9690\u85CF\u6307\u4EE4\uFF1A\u77E9\u9635\u8D85\u9891"
    },
    {
        cmd: "jkl",
        desc: "\u5BF9\u6697\u53F7"
    },
    {
        cmd: "panzer",
        desc: "\u9690\u85CF\u6307\u4EE4\uFF1A\u53EC\u5524\u5766\u514B"
    },
    {
        cmd: "clear",
        desc: "\u6E05\u5C4F"
    },
    {
        cmd: "exit",
        desc: "\u5173\u95ED\u7EC8\u7AEF"
    }
];
const $dd00c3b72143464c$var$COFFEE = [
    "        ( (",
    "         ) )",
    "      .........",
    "      |       |___",
    "      |       |   ]",
    "      `-------'---'",
    "sudo: \u6743\u9650\u88AB\u62D2\u7EDD \u2014\u2014 \u5496\u5561\u673A\u4E0D\u5728\u670D\u52A1\u533A\u3002\u5BFC\u6F14\u8BF7\u5148\u4E0B\u5355\u3002"
];
function $dd00c3b72143464c$export$2e2bcd8739ae039(matrixApi) {
    const dock = document.getElementById("tk-dock");
    const toggle = document.getElementById("tk-toggle");
    const panel = document.getElementById("tk-panel");
    const closeBtn = document.getElementById("tk-close");
    const log = document.getElementById("tk-log");
    const input = document.getElementById("tk-input");
    if (!dock || !toggle || !panel || !log || !input) return;
    const print = (text, cls = "")=>{
        const p = document.createElement("p");
        if (cls) p.className = cls;
        p.textContent = text;
        log.appendChild(p);
        log.scrollTop = log.scrollHeight;
    };
    const echo = (cmd)=>{
        const p = document.createElement("p");
        p.innerHTML = `<span style="color:#00ff9c">jkl@jkdy:~$</span> ${escapeHtml(cmd)}`;
        log.appendChild(p);
        log.scrollTop = log.scrollHeight;
    };
    const escapeHtml = (s)=>s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
    const open = ()=>{
        panel.classList.add("is-open");
        panel.setAttribute("aria-hidden", "false");
        toggle.setAttribute("aria-expanded", "true");
        toggle.style.display = "none";
        setTimeout(()=>input.focus(), 120);
    };
    const close = ()=>{
        panel.classList.remove("is-open");
        panel.setAttribute("aria-hidden", "true");
        toggle.setAttribute("aria-expanded", "false");
        toggle.style.display = "";
    };
    toggle.addEventListener("click", open);
    closeBtn.addEventListener("click", close);
    const dispatch = (raw)=>{
        const cmd = raw.trim().toLowerCase();
        echo(raw.trim() || " ");
        if (cmd === "help" || cmd === "?") {
            print("\u53EF\u7528\u6307\u4EE4\uFF1A", "c-info");
            $dd00c3b72143464c$var$HELP.forEach((h)=>print(`  ${h.cmd.padEnd(14)} \u{2014} ${h.desc}`, "c-dim"));
        } else if (cmd === "whoami") {
            print("\u6781\u5BA2\u5BFC\u6F14 \u2014\u2014 \u72EC\u7ACB AI \u521B\u4F5C\u8005 / \u81EA\u5A92\u4F53\u4EBA", "c-ok");
            print("\u4E13\u6CE8 AI \u89C6\u9891 \xb7 AI \u56FE\u50CF \xb7 AI \u97F3\u4E50\uFF0C\u8BA9\u60F3\u8C61\u5373\u523B\u6210\u7247\u3002", "c-ok");
        } else if (cmd === "date") print(new Date().toLocaleString("zh-CN", {
            hour12: false
        }), "c-info");
        else if (cmd === "projects") {
            print("render_video.sh  \u2014 AI \u89C6\u9891\u6210\u7247", "c-ok");
            print("generate_image.py \u2014 AI \u56FE\u50CF\u751F\u6210", "c-ok");
            print("compose_music.py \u2014 AI \u97F3\u4E50\u4F5C\u66F2", "c-ok");
        } else if (cmd === "matrix on") {
            matrixApi?.setMode("normal");
            print("\u77E9\u9635\u96E8\u5DF2\u542F\u52A8\u3002\u6B22\u8FCE\u6765\u5230\u77E9\u9635\uFF0C\u5BFC\u6F14\u3002", "c-ok");
        } else if (cmd === "matrix off") {
            matrixApi?.setMode("off");
            print("\u77E9\u9635\u96E8\u5DF2\u5173\u95ED\u3002\u73B0\u5B9E\u4E16\u754C\u6709\u70B9\u65E0\u804A\u3002", "c-dim");
        } else if (cmd === "glitch") {
            (0, $bfc1bd9ef2af3f3a$export$8cc04514940e4c06)(2200);
            print("GLITCH MODE: ON (2.2s)", "c-err");
            (0, $bfc1bd9ef2af3f3a$export$f6cef6fcf9ca4e17)("\u26A0 \u7CFB\u7EDF\u6545\u969C\u5DF2\u6CE8\u5165 \u2014\u2014 \u4E00\u5207\u6B63\u5E38\uFF08\u5927\u6982\uFF09", 2400);
        } else if (cmd === "konami") {
            matrixApi?.setMode("overdrive");
            (0, $bfc1bd9ef2af3f3a$export$8cc04514940e4c06)(1400);
            print("MATRIX OVERDRIVE \u2713 \u77E9\u9635\u5DF2\u8D85\u9891 8 \u79D2", "c-err");
            (0, $bfc1bd9ef2af3f3a$export$f6cef6fcf9ca4e17)("\uD83D\uDD79 KONAMI \u6307\u4EE4\u5DF2\u6267\u884C\uFF1A\u77E9\u9635\u8D85\u9891\u6A21\u5F0F", 3000);
        } else if (cmd === "jkl") {
            print("\u6697\u53F7\u6B63\u786E\u3002\u4F60\u5F88\u6709\u54C1\u5473\uFF0C\u5BFC\u6F14\u3002", "c-ok");
            (0, $bfc1bd9ef2af3f3a$export$f6cef6fcf9ca4e17)("\uD83D\uDD76 JKDY \u6697\u53F7\u5DF2\u8BC6\u522B", 2400);
        } else if (cmd === "panzer") {
            // GTA 坦克秘籍：终端触发坦克彩蛋（与键盘序列 panzer 同特效）
            (0, $bfc1bd9ef2af3f3a$export$9e738c6099686bcf)();
            print("RHINO \u5766\u514B\u5DF2\u90E8\u7F72 \u2014\u2014 \u611F\u89C9\u88AB\u53D1\u73B0\u4E86\u5417\uFF1F", "c-ok");
            (0, $bfc1bd9ef2af3f3a$export$f6cef6fcf9ca4e17)("\uD83E\uDE96 PANZER \u6307\u4EE4\u5DF2\u6267\u884C\uFF1A\u5766\u514B\u5DF2\u90E8\u7F72", 3200);
        } else if (cmd === "sudo make-me-coffee") $dd00c3b72143464c$var$COFFEE.forEach((l)=>print(l, l.includes("sudo") ? "c-err" : "c-dim"));
        else if (cmd === "sudo rm -rf /") {
            print("nice try, hacker. \u7CFB\u7EDF\u8868\u793A\u62D2\u7EDD\u6267\u884C\u3002", "c-err");
            (0, $bfc1bd9ef2af3f3a$export$f6cef6fcf9ca4e17)("\uD83D\uDEAB \u68C0\u6D4B\u5230\u5371\u9669\u6307\u4EE4\uFF0C\u5DF2\u88AB\u62E6\u622A", 2600);
        } else if (cmd === "clear" || cmd === "cls") log.innerHTML = "";
        else if (cmd === "exit") {
            print("\u65AD\u5F00\u8FDE\u63A5\u3002\u4E0B\u6B21\u5F00\u673A\uFF0C\u4F9D\u65E7\u662F\u5BFC\u6F14\u3002", "c-dim");
            setTimeout(close, 450);
        } else if (!cmd) ;
        else print(`zsh: command not found: ${raw.trim()} \u{2014} \u{8F93}\u{5165} help \u{67E5}\u{770B}\u{53EF}\u{7528}\u{6307}\u{4EE4}`, "c-err");
    };
    input.addEventListener("keydown", (e)=>{
        if (e.key === "Enter") {
            dispatch(input.value);
            input.value = "";
        } else if (e.key === "Escape") close();
        e.stopPropagation();
    });
    // 初始欢迎语
    print("JKDY://TERMINAL v2.6.6 \u2014 \u8FDE\u63A5\u6210\u529F", "c-dim");
    print("\u8F93\u5165 help \u67E5\u770B\u53EF\u7528\u6307\u4EE4\uFF0C\u8BD5\u8BD5 konami \u6216 jkl\u3002", "c-dim");
}


// ============================================================
// 彩蛋：Konami 指令 + Logo 连点 + 键盘暗号 jkl + PANZER 坦克 + 光标光晕
// ============================================================

const $4d930d60ee20c2f7$var$KONAMI = [
    "ArrowUp",
    "ArrowUp",
    "ArrowDown",
    "ArrowDown",
    "ArrowLeft",
    "ArrowRight",
    "ArrowLeft",
    "ArrowRight",
    "b",
    "a"
];
function $4d930d60ee20c2f7$export$2e2bcd8739ae039(matrixApi) {
    // ---------- 光标光晕（仅精确指针设备） ----------
    if (window.matchMedia("(pointer: fine)").matches) {
        const glow = document.createElement("div");
        glow.className = "cursor-glow";
        document.body.appendChild(glow);
        let tx = -100;
        let ty = -100;
        let x = -100;
        let y = -100;
        let raf = 0;
        document.addEventListener("mousemove", (e)=>{
            tx = e.clientX;
            ty = e.clientY;
            if (!raf) raf = requestAnimationFrame(move);
        });
        const move = ()=>{
            raf = 0;
            x += (tx - x) * 0.16;
            y += (ty - y) * 0.16;
            glow.style.transform = `translate(${x - 110}px, ${y - 110}px)`;
            if (Math.abs(tx - x) > 0.5 || Math.abs(ty - y) > 0.5) raf = requestAnimationFrame(move);
        };
    }
    // ---------- Konami ----------
    let seq = [];
    document.addEventListener("keydown", (e)=>{
        // 终端输入框内不触发键盘彩蛋
        const tag = document.activeElement?.tagName;
        if (tag === "INPUT" || tag === "TEXTAREA") return;
        const key = e.key.length === 1 ? e.key.toLowerCase() : e.key;
        seq.push(key);
        if (seq.length > $4d930d60ee20c2f7$var$KONAMI.length) seq.shift();
        const hit = seq.length === $4d930d60ee20c2f7$var$KONAMI.length && seq.every((k, i)=>k === $4d930d60ee20c2f7$var$KONAMI[i]);
        if (hit) {
            seq = [];
            matrixApi?.setMode("overdrive");
            (0, $bfc1bd9ef2af3f3a$export$8cc04514940e4c06)(1500);
            (0, $bfc1bd9ef2af3f3a$export$f6cef6fcf9ca4e17)("\uD83D\uDD79 KONAMI \u2713 \u5DF2\u89E3\u9501\uFF1A\u77E9\u9635\u8D85\u9891\u6A21\u5F0F\uFF088 \u79D2\uFF09", 3600);
        }
    });
    // ---------- 键盘暗号：jkl ----------
    let buffer = "";
    document.addEventListener("keydown", (e)=>{
        const tag = document.activeElement?.tagName;
        if (tag === "INPUT" || tag === "TEXTAREA") return;
        if (!/^[a-z]$/i.test(e.key)) {
            buffer = "";
            return;
        }
        buffer = (buffer + e.key.toLowerCase()).slice(-3);
        if (buffer === "jkl") {
            buffer = "";
            matrixApi?.setMode("overdrive");
            (0, $bfc1bd9ef2af3f3a$export$f6cef6fcf9ca4e17)("\uD83D\uDD76 \u6697\u53F7 JKDY \u5DF2\u8BC6\u522B \u2014\u2014 \u5BFC\u6F14\u4E00\u76F4\u5728\u7EBF", 3400);
        }
    });
    // ---------- PANZER：GTA 罪恶都市坦克秘籍 ----------
    // 键盘连续输入 p-a-n-z-e-r（大小写均可）触发坦克彩蛋
    const PANZER = [
        "p",
        "a",
        "n",
        "z",
        "e",
        "r"
    ];
    let panzerSeq = [];
    document.addEventListener("keydown", (e)=>{
        const tag = document.activeElement?.tagName;
        if (tag === "INPUT" || tag === "TEXTAREA") return;
        // 仅接受字母按键，非字母（方向键等）重置序列
        const key = e.key.length === 1 ? e.key.toLowerCase() : "";
        if (!key) {
            panzerSeq = [];
            return;
        }
        panzerSeq.push(key);
        if (panzerSeq.length > PANZER.length) panzerSeq.shift();
        // 完整匹配 panzer 序列后触发
        if (panzerSeq.length === PANZER.length && panzerSeq.every((k, i)=>k === PANZER[i])) {
            panzerSeq = [];
            (0, $bfc1bd9ef2af3f3a$export$9e738c6099686bcf)();
            (0, $bfc1bd9ef2af3f3a$export$f6cef6fcf9ca4e17)("\uD83E\uDE96 PANZER \u2713 \u5766\u514B\u5DF2\u90E8\u7F72 \u2014\u2014 RHINO \u5DF2\u5C31\u4F4D", 3400);
        }
    });
    // ---------- Logo 连点 ----------
    const logo = document.getElementById("nav-logo");
    if (logo) {
        let clicks = 0;
        let resetTimer = null;
        logo.addEventListener("click", ()=>{
            clicks += 1;
            clearTimeout(resetTimer);
            resetTimer = setTimeout(()=>clicks = 0, 2000);
            if (clicks >= 5) {
                clicks = 0;
                (0, $bfc1bd9ef2af3f3a$export$8cc04514940e4c06)(1200);
                (0, $bfc1bd9ef2af3f3a$export$f6cef6fcf9ca4e17)("\u5BFC\u6F14\u5728\u5417\uFF1F\u2014\u2014 \u5728\u7684\uFF0C\u4E00\u76F4\u5728\u3002\u7CFB\u7EDF\u4ECE\u672A\u4E0B\u7EBF\u3002", 3600);
            }
        });
    }
}


var $b5f6d4efc654cf78$exports = {};
'use strict';
var $b5f6d4efc654cf78$var$classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
/**
 * Created by Sergiu Șandor (micku7zu) on 1/27/2017.
 * Original idea: https://github.com/gijsroge/tilt.js
 * MIT License.
 * Version 1.8.1
 */ var $b5f6d4efc654cf78$var$VanillaTilt = function() {
    function VanillaTilt(element) {
        var settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        $b5f6d4efc654cf78$var$classCallCheck(this, VanillaTilt);
        if (!(element instanceof Node)) throw "Can't initialize VanillaTilt because " + element + " is not a Node.";
        this.width = null;
        this.height = null;
        this.clientWidth = null;
        this.clientHeight = null;
        this.left = null;
        this.top = null;
        // for Gyroscope sampling
        this.gammazero = null;
        this.betazero = null;
        this.lastgammazero = null;
        this.lastbetazero = null;
        this.transitionTimeout = null;
        this.updateCall = null;
        this.event = null;
        this.updateBind = this.update.bind(this);
        this.resetBind = this.reset.bind(this);
        this.element = element;
        this.settings = this.extendSettings(settings);
        this.reverse = this.settings.reverse ? -1 : 1;
        this.resetToStart = VanillaTilt.isSettingTrue(this.settings["reset-to-start"]);
        this.glare = VanillaTilt.isSettingTrue(this.settings.glare);
        this.glarePrerender = VanillaTilt.isSettingTrue(this.settings["glare-prerender"]);
        this.fullPageListening = VanillaTilt.isSettingTrue(this.settings["full-page-listening"]);
        this.gyroscope = VanillaTilt.isSettingTrue(this.settings.gyroscope);
        this.gyroscopeSamples = this.settings.gyroscopeSamples;
        this.elementListener = this.getElementListener();
        if (this.glare) this.prepareGlare();
        if (this.fullPageListening) this.updateClientSize();
        this.addEventListeners();
        this.reset();
        if (this.resetToStart === false) {
            this.settings.startX = 0;
            this.settings.startY = 0;
        }
    }
    VanillaTilt.isSettingTrue = function isSettingTrue(setting) {
        return setting === "" || setting === true || setting === 1;
    };
    /**
   * Method returns element what will be listen mouse events
   * @return {Node}
   */ VanillaTilt.prototype.getElementListener = function getElementListener() {
        if (this.fullPageListening) return window.document;
        if (typeof this.settings["mouse-event-element"] === "string") {
            var mouseEventElement = document.querySelector(this.settings["mouse-event-element"]);
            if (mouseEventElement) return mouseEventElement;
        }
        if (this.settings["mouse-event-element"] instanceof Node) return this.settings["mouse-event-element"];
        return this.element;
    };
    /**
   * Method set listen methods for this.elementListener
   * @return {Node}
   */ VanillaTilt.prototype.addEventListeners = function addEventListeners() {
        this.onMouseEnterBind = this.onMouseEnter.bind(this);
        this.onMouseMoveBind = this.onMouseMove.bind(this);
        this.onMouseLeaveBind = this.onMouseLeave.bind(this);
        this.onWindowResizeBind = this.onWindowResize.bind(this);
        this.onDeviceOrientationBind = this.onDeviceOrientation.bind(this);
        this.elementListener.addEventListener("mouseenter", this.onMouseEnterBind);
        this.elementListener.addEventListener("mouseleave", this.onMouseLeaveBind);
        this.elementListener.addEventListener("mousemove", this.onMouseMoveBind);
        if (this.glare || this.fullPageListening) window.addEventListener("resize", this.onWindowResizeBind);
        if (this.gyroscope) window.addEventListener("deviceorientation", this.onDeviceOrientationBind);
    };
    /**
   * Method remove event listeners from current this.elementListener
   */ VanillaTilt.prototype.removeEventListeners = function removeEventListeners() {
        this.elementListener.removeEventListener("mouseenter", this.onMouseEnterBind);
        this.elementListener.removeEventListener("mouseleave", this.onMouseLeaveBind);
        this.elementListener.removeEventListener("mousemove", this.onMouseMoveBind);
        if (this.gyroscope) window.removeEventListener("deviceorientation", this.onDeviceOrientationBind);
        if (this.glare || this.fullPageListening) window.removeEventListener("resize", this.onWindowResizeBind);
    };
    VanillaTilt.prototype.destroy = function destroy() {
        clearTimeout(this.transitionTimeout);
        if (this.updateCall !== null) cancelAnimationFrame(this.updateCall);
        this.element.style.willChange = "";
        this.element.style.transition = "";
        this.element.style.transform = "";
        this.resetGlare();
        this.removeEventListeners();
        this.element.vanillaTilt = null;
        delete this.element.vanillaTilt;
        this.element = null;
    };
    VanillaTilt.prototype.onDeviceOrientation = function onDeviceOrientation(event) {
        if (event.gamma === null || event.beta === null) return;
        this.updateElementPosition();
        if (this.gyroscopeSamples > 0) {
            this.lastgammazero = this.gammazero;
            this.lastbetazero = this.betazero;
            if (this.gammazero === null) {
                this.gammazero = event.gamma;
                this.betazero = event.beta;
            } else {
                this.gammazero = (event.gamma + this.lastgammazero) / 2;
                this.betazero = (event.beta + this.lastbetazero) / 2;
            }
            this.gyroscopeSamples -= 1;
        }
        var totalAngleX = this.settings.gyroscopeMaxAngleX - this.settings.gyroscopeMinAngleX;
        var totalAngleY = this.settings.gyroscopeMaxAngleY - this.settings.gyroscopeMinAngleY;
        var degreesPerPixelX = totalAngleX / this.width;
        var degreesPerPixelY = totalAngleY / this.height;
        var angleX = event.gamma - (this.settings.gyroscopeMinAngleX + this.gammazero);
        var angleY = event.beta - (this.settings.gyroscopeMinAngleY + this.betazero);
        var posX = angleX / degreesPerPixelX;
        var posY = angleY / degreesPerPixelY;
        if (this.updateCall !== null) cancelAnimationFrame(this.updateCall);
        this.event = {
            clientX: posX + this.left,
            clientY: posY + this.top
        };
        this.updateCall = requestAnimationFrame(this.updateBind);
    };
    VanillaTilt.prototype.onMouseEnter = function onMouseEnter() {
        this.updateElementPosition();
        this.element.style.willChange = "transform";
        this.setTransition();
    };
    VanillaTilt.prototype.onMouseMove = function onMouseMove(event) {
        if (this.updateCall !== null) cancelAnimationFrame(this.updateCall);
        this.event = event;
        this.updateCall = requestAnimationFrame(this.updateBind);
    };
    VanillaTilt.prototype.onMouseLeave = function onMouseLeave() {
        this.setTransition();
        if (this.settings.reset) requestAnimationFrame(this.resetBind);
    };
    VanillaTilt.prototype.reset = function reset() {
        this.onMouseEnter();
        if (this.fullPageListening) this.event = {
            clientX: (this.settings.startX + this.settings.max) / (2 * this.settings.max) * this.clientWidth,
            clientY: (this.settings.startY + this.settings.max) / (2 * this.settings.max) * this.clientHeight
        };
        else this.event = {
            clientX: this.left + (this.settings.startX + this.settings.max) / (2 * this.settings.max) * this.width,
            clientY: this.top + (this.settings.startY + this.settings.max) / (2 * this.settings.max) * this.height
        };
        var backupScale = this.settings.scale;
        this.settings.scale = 1;
        this.update();
        this.settings.scale = backupScale;
        this.resetGlare();
    };
    VanillaTilt.prototype.resetGlare = function resetGlare() {
        if (this.glare) {
            this.glareElement.style.transform = "rotate(180deg) translate(-50%, -50%)";
            this.glareElement.style.opacity = "0";
        }
    };
    VanillaTilt.prototype.getValues = function getValues() {
        var x = void 0, y = void 0;
        if (this.fullPageListening) {
            x = this.event.clientX / this.clientWidth;
            y = this.event.clientY / this.clientHeight;
        } else {
            x = (this.event.clientX - this.left) / this.width;
            y = (this.event.clientY - this.top) / this.height;
        }
        x = Math.min(Math.max(x, 0), 1);
        y = Math.min(Math.max(y, 0), 1);
        var tiltX = (this.reverse * (this.settings.max - x * this.settings.max * 2)).toFixed(2);
        var tiltY = (this.reverse * (y * this.settings.max * 2 - this.settings.max)).toFixed(2);
        var angle = Math.atan2(this.event.clientX - (this.left + this.width / 2), -(this.event.clientY - (this.top + this.height / 2))) * (180 / Math.PI);
        return {
            tiltX: tiltX,
            tiltY: tiltY,
            percentageX: x * 100,
            percentageY: y * 100,
            angle: angle
        };
    };
    VanillaTilt.prototype.updateElementPosition = function updateElementPosition() {
        var rect = this.element.getBoundingClientRect();
        this.width = this.element.offsetWidth;
        this.height = this.element.offsetHeight;
        this.left = rect.left;
        this.top = rect.top;
    };
    VanillaTilt.prototype.update = function update() {
        var values = this.getValues();
        this.element.style.transform = "perspective(" + this.settings.perspective + "px) " + "rotateX(" + (this.settings.axis === "x" ? 0 : values.tiltY) + "deg) " + "rotateY(" + (this.settings.axis === "y" ? 0 : values.tiltX) + "deg) " + "scale3d(" + this.settings.scale + ", " + this.settings.scale + ", " + this.settings.scale + ")";
        if (this.glare) {
            this.glareElement.style.transform = "rotate(" + values.angle + "deg) translate(-50%, -50%)";
            this.glareElement.style.opacity = "" + values.percentageY * this.settings["max-glare"] / 100;
        }
        this.element.dispatchEvent(new CustomEvent("tiltChange", {
            "detail": values
        }));
        this.updateCall = null;
    };
    /**
   * Appends the glare element (if glarePrerender equals false)
   * and sets the default style
   */ VanillaTilt.prototype.prepareGlare = function prepareGlare() {
        // If option pre-render is enabled we assume all html/css is present for an optimal glare effect.
        if (!this.glarePrerender) {
            // Create glare element
            var jsTiltGlare = document.createElement("div");
            jsTiltGlare.classList.add("js-tilt-glare");
            var jsTiltGlareInner = document.createElement("div");
            jsTiltGlareInner.classList.add("js-tilt-glare-inner");
            jsTiltGlare.appendChild(jsTiltGlareInner);
            this.element.appendChild(jsTiltGlare);
        }
        this.glareElementWrapper = this.element.querySelector(".js-tilt-glare");
        this.glareElement = this.element.querySelector(".js-tilt-glare-inner");
        if (this.glarePrerender) return;
        Object.assign(this.glareElementWrapper.style, {
            "position": "absolute",
            "top": "0",
            "left": "0",
            "width": "100%",
            "height": "100%",
            "overflow": "hidden",
            "pointer-events": "none",
            "border-radius": "inherit"
        });
        Object.assign(this.glareElement.style, {
            "position": "absolute",
            "top": "50%",
            "left": "50%",
            "pointer-events": "none",
            "background-image": "linear-gradient(0deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 100%)",
            "transform": "rotate(180deg) translate(-50%, -50%)",
            "transform-origin": "0% 0%",
            "opacity": "0"
        });
        this.updateGlareSize();
    };
    VanillaTilt.prototype.updateGlareSize = function updateGlareSize() {
        if (this.glare) {
            var glareSize = (this.element.offsetWidth > this.element.offsetHeight ? this.element.offsetWidth : this.element.offsetHeight) * 2;
            Object.assign(this.glareElement.style, {
                "width": glareSize + "px",
                "height": glareSize + "px"
            });
        }
    };
    VanillaTilt.prototype.updateClientSize = function updateClientSize() {
        this.clientWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        this.clientHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
    };
    VanillaTilt.prototype.onWindowResize = function onWindowResize() {
        this.updateGlareSize();
        this.updateClientSize();
    };
    VanillaTilt.prototype.setTransition = function setTransition() {
        var _this = this;
        clearTimeout(this.transitionTimeout);
        this.element.style.transition = this.settings.speed + "ms " + this.settings.easing;
        if (this.glare) this.glareElement.style.transition = "opacity " + this.settings.speed + "ms " + this.settings.easing;
        this.transitionTimeout = setTimeout(function() {
            _this.element.style.transition = "";
            if (_this.glare) _this.glareElement.style.transition = "";
        }, this.settings.speed);
    };
    /**
   * Method return patched settings of instance
   * @param {boolean} settings.reverse - reverse the tilt direction
   * @param {number} settings.max - max tilt rotation (degrees)
   * @param {startX} settings.startX - the starting tilt on the X axis, in degrees. Default: 0
   * @param {startY} settings.startY - the starting tilt on the Y axis, in degrees. Default: 0
   * @param {number} settings.perspective - Transform perspective, the lower the more extreme the tilt gets
   * @param {string} settings.easing - Easing on enter/exit
   * @param {number} settings.scale - 2 = 200%, 1.5 = 150%, etc..
   * @param {number} settings.speed - Speed of the enter/exit transition
   * @param {boolean} settings.transition - Set a transition on enter/exit
   * @param {string|null} settings.axis - What axis should be enabled. Can be "x" or "y"
   * @param {boolean} settings.glare - if it should have a "glare" effect
   * @param {number} settings.max-glare - the maximum "glare" opacity (1 = 100%, 0.5 = 50%)
   * @param {boolean} settings.glare-prerender - false = VanillaTilt creates the glare elements for you, otherwise
   * @param {boolean} settings.full-page-listening - If true, parallax effect will listen to mouse move events on the whole document, not only the selected element
   * @param {string|object} settings.mouse-event-element - String selector or link to HTML-element what will be listen mouse events
   * @param {boolean} settings.reset - false = If the tilt effect has to be reset on exit
   * @param {boolean} settings.reset-to-start - true = On reset event (mouse leave) will return to initial start angle (if startX or startY is set)
   * @param {gyroscope} settings.gyroscope - Enable tilting by deviceorientation events
   * @param {gyroscopeSensitivity} settings.gyroscopeSensitivity - Between 0 and 1 - The angle at which max tilt position is reached. 1 = 90deg, 0.5 = 45deg, etc..
   * @param {gyroscopeSamples} settings.gyroscopeSamples - How many gyroscope moves to decide the starting position.
   */ VanillaTilt.prototype.extendSettings = function extendSettings(settings) {
        var defaultSettings = {
            reverse: false,
            max: 15,
            startX: 0,
            startY: 0,
            perspective: 1000,
            easing: "cubic-bezier(.03,.98,.52,.99)",
            scale: 1,
            speed: 300,
            transition: true,
            axis: null,
            glare: false,
            "max-glare": 1,
            "glare-prerender": false,
            "full-page-listening": false,
            "mouse-event-element": null,
            reset: true,
            "reset-to-start": true,
            gyroscope: true,
            gyroscopeMinAngleX: -45,
            gyroscopeMaxAngleX: 45,
            gyroscopeMinAngleY: -45,
            gyroscopeMaxAngleY: 45,
            gyroscopeSamples: 10
        };
        var newSettings = {};
        for(var property in defaultSettings){
            if (property in settings) newSettings[property] = settings[property];
            else if (this.element.hasAttribute("data-tilt-" + property)) {
                var attribute = this.element.getAttribute("data-tilt-" + property);
                try {
                    newSettings[property] = JSON.parse(attribute);
                } catch (e) {
                    newSettings[property] = attribute;
                }
            } else newSettings[property] = defaultSettings[property];
        }
        return newSettings;
    };
    VanillaTilt.init = function init(elements, settings) {
        if (elements instanceof Node) elements = [
            elements
        ];
        if (elements instanceof NodeList) elements = [].slice.call(elements);
        if (!(elements instanceof Array)) return;
        elements.forEach(function(element) {
            if (!("vanillaTilt" in element)) element.vanillaTilt = new VanillaTilt(element, settings);
        });
    };
    return VanillaTilt;
}();
if (typeof document !== "undefined") {
    /* expose the class to window */ window.VanillaTilt = $b5f6d4efc654cf78$var$VanillaTilt;
    /**
   * Auto load
   */ $b5f6d4efc654cf78$var$VanillaTilt.init(document.querySelectorAll("[data-tilt]"));
}
$b5f6d4efc654cf78$exports = $b5f6d4efc654cf78$var$VanillaTilt;


function $b8855ed206bb3c2e$export$2e2bcd8739ae039() {
    const elements = document.querySelectorAll(".js-tilt");
    (0, (/*@__PURE__*/$parcel$interopDefault($b5f6d4efc654cf78$exports))).init(elements);
}


// ============================================================
// 烟花：点击「发送信号」后全屏绽放 20 秒（Canvas 粒子系统）
// - 全屏覆盖层，置于页面最前（z-index 最高）
// - pointer-events: none，不遮挡任何交互
// - 20s 内持续发射火箭，结束后粒子自然消散并自动移除画布
// ============================================================

const $2e4251c004ae6dfb$var$FIREWORK_MS = 20000; // 烟花持续时长
const $2e4251c004ae6dfb$var$COLORS = [
    "#00ff9c",
    "#00e5ff",
    "#ff2e88",
    "#ffb000",
    "#e8f4ff"
];
const $2e4251c004ae6dfb$var$ROCKET_GAP = [
    360,
    720
]; // 两枚火箭的随机发射间隔（ms）
let $2e4251c004ae6dfb$var$canvas = null;
let $2e4251c004ae6dfb$var$ctx = null;
let $2e4251c004ae6dfb$var$raf = 0;
let $2e4251c004ae6dfb$var$running = false;
let $2e4251c004ae6dfb$var$startedAt = 0;
let $2e4251c004ae6dfb$var$nextRocketAt = 0;
let $2e4251c004ae6dfb$var$rockets = [];
let $2e4251c004ae6dfb$var$sparks = [];
let $2e4251c004ae6dfb$var$onResize = null;
let $2e4251c004ae6dfb$var$stopTimer = null;
const $2e4251c004ae6dfb$var$rand = (a, b)=>a + Math.random() * (b - a);
const $2e4251c004ae6dfb$var$pick = (arr)=>arr[Math.floor(Math.random() * arr.length)];
function $2e4251c004ae6dfb$var$ensureCanvas() {
    if ($2e4251c004ae6dfb$var$canvas) return;
    $2e4251c004ae6dfb$var$canvas = document.createElement("canvas");
    $2e4251c004ae6dfb$var$canvas.className = "fireworks-canvas";
    $2e4251c004ae6dfb$var$canvas.setAttribute("aria-hidden", "true");
    document.body.appendChild($2e4251c004ae6dfb$var$canvas);
    $2e4251c004ae6dfb$var$ctx = $2e4251c004ae6dfb$var$canvas.getContext("2d");
    $2e4251c004ae6dfb$var$resize();
    $2e4251c004ae6dfb$var$onResize = $2e4251c004ae6dfb$var$resize;
    window.addEventListener("resize", $2e4251c004ae6dfb$var$onResize);
}
function $2e4251c004ae6dfb$var$resize() {
    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    $2e4251c004ae6dfb$var$canvas.width = Math.floor(window.innerWidth * dpr);
    $2e4251c004ae6dfb$var$canvas.height = Math.floor(window.innerHeight * dpr);
    $2e4251c004ae6dfb$var$ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
}
function $2e4251c004ae6dfb$var$launchRocket() {
    const w = window.innerWidth;
    const h = window.innerHeight;
    $2e4251c004ae6dfb$var$rockets.push({
        x: $2e4251c004ae6dfb$var$rand(w * 0.12, w * 0.88),
        y: h + 10,
        vy: -$2e4251c004ae6dfb$var$rand(8.5, 12.5),
        color: $2e4251c004ae6dfb$var$pick($2e4251c004ae6dfb$var$COLORS),
        targetY: $2e4251c004ae6dfb$var$rand(h * 0.15, h * 0.45),
        trail: []
    });
}
function $2e4251c004ae6dfb$var$explode(r) {
    const n = 56 + Math.floor(Math.random() * 40);
    for(let i = 0; i < n; i++){
        const angle = Math.PI * 2 * i / n + $2e4251c004ae6dfb$var$rand(-0.18, 0.18);
        const speed = $2e4251c004ae6dfb$var$rand(1.5, 5.6);
        $2e4251c004ae6dfb$var$sparks.push({
            x: r.x,
            y: r.y,
            vx: Math.cos(angle) * speed,
            vy: Math.sin(angle) * speed,
            life: 1,
            decay: $2e4251c004ae6dfb$var$rand(0.011, 0.02),
            color: r.color,
            size: $2e4251c004ae6dfb$var$rand(1.2, 2.6)
        });
    }
}
function $2e4251c004ae6dfb$var$drawSparks(w, h) {
    for(let i = $2e4251c004ae6dfb$var$sparks.length - 1; i >= 0; i--){
        const s = $2e4251c004ae6dfb$var$sparks[i];
        s.x += s.vx;
        s.y += s.vy;
        s.vy += 0.042; // 重力
        s.vx *= 0.985; // 空气阻力
        s.vy *= 0.985;
        s.life -= s.decay;
        if (s.life <= 0 || s.y > h + 24 || s.x < -24 || s.x > w + 24) {
            $2e4251c004ae6dfb$var$sparks.splice(i, 1);
            continue;
        }
        $2e4251c004ae6dfb$var$ctx.globalAlpha = Math.max(s.life, 0);
        $2e4251c004ae6dfb$var$ctx.fillStyle = s.color;
        $2e4251c004ae6dfb$var$ctx.beginPath();
        $2e4251c004ae6dfb$var$ctx.arc(s.x, s.y, s.size, 0, Math.PI * 2);
        $2e4251c004ae6dfb$var$ctx.fill();
    }
}
function $2e4251c004ae6dfb$var$drawRockets() {
    for(let i = $2e4251c004ae6dfb$var$rockets.length - 1; i >= 0; i--){
        const r = $2e4251c004ae6dfb$var$rockets[i];
        r.trail.push({
            x: r.x,
            y: r.y,
            life: 0.55
        });
        r.y += r.vy;
        r.vy += 0.055; // 上升减速
        // 到达目标高度或速度耗尽 → 爆炸
        if (r.y <= r.targetY || r.vy >= -0.9) {
            $2e4251c004ae6dfb$var$explode(r);
            $2e4251c004ae6dfb$var$rockets.splice(i, 1);
            continue;
        }
        // 拖尾
        for(let j = r.trail.length - 1; j >= 0; j--){
            const t = r.trail[j];
            $2e4251c004ae6dfb$var$ctx.globalAlpha = Math.max(t.life, 0);
            $2e4251c004ae6dfb$var$ctx.fillStyle = r.color;
            $2e4251c004ae6dfb$var$ctx.fillRect(t.x, t.y, 2, 2);
            t.life -= 0.045;
            if (t.life <= 0) r.trail.splice(j, 1);
        }
        // 火箭头
        $2e4251c004ae6dfb$var$ctx.globalAlpha = 1;
        $2e4251c004ae6dfb$var$ctx.fillStyle = "#e8f4ff";
        $2e4251c004ae6dfb$var$ctx.fillRect(r.x - 1.5, r.y - 3, 3, 7);
    }
    $2e4251c004ae6dfb$var$ctx.globalAlpha = 1;
}
function $2e4251c004ae6dfb$var$tick() {
    $2e4251c004ae6dfb$var$raf = requestAnimationFrame($2e4251c004ae6dfb$var$tick);
    const now = performance.now();
    const elapsed = now - $2e4251c004ae6dfb$var$startedAt;
    const w = window.innerWidth;
    const h = window.innerHeight;
    $2e4251c004ae6dfb$var$ctx.clearRect(0, 0, w, h);
    // 20s 内持续发射
    if (elapsed < $2e4251c004ae6dfb$var$FIREWORK_MS && now >= $2e4251c004ae6dfb$var$nextRocketAt) {
        $2e4251c004ae6dfb$var$launchRocket();
        $2e4251c004ae6dfb$var$nextRocketAt = now + $2e4251c004ae6dfb$var$rand($2e4251c004ae6dfb$var$ROCKET_GAP[0], $2e4251c004ae6dfb$var$ROCKET_GAP[1]);
    }
    $2e4251c004ae6dfb$var$drawSparks(w, h);
    $2e4251c004ae6dfb$var$drawRockets();
    // 结束后等粒子自然消散，再移除画布
    if (elapsed >= $2e4251c004ae6dfb$var$FIREWORK_MS && $2e4251c004ae6dfb$var$rockets.length === 0 && $2e4251c004ae6dfb$var$sparks.length === 0) $2e4251c004ae6dfb$var$stop();
}
function $2e4251c004ae6dfb$var$launchFireworks() {
    $2e4251c004ae6dfb$var$ensureCanvas();
    $2e4251c004ae6dfb$var$rockets = [];
    $2e4251c004ae6dfb$var$sparks = [];
    $2e4251c004ae6dfb$var$startedAt = performance.now();
    $2e4251c004ae6dfb$var$nextRocketAt = $2e4251c004ae6dfb$var$startedAt + 240;
    // 兜底：无论 rAF 是否受限，20s 后必然停止并移除画布
    clearTimeout($2e4251c004ae6dfb$var$stopTimer);
    $2e4251c004ae6dfb$var$stopTimer = setTimeout($2e4251c004ae6dfb$var$stop, $2e4251c004ae6dfb$var$FIREWORK_MS + 2500);
    if (!$2e4251c004ae6dfb$var$running) {
        $2e4251c004ae6dfb$var$running = true;
        $2e4251c004ae6dfb$var$raf = requestAnimationFrame($2e4251c004ae6dfb$var$tick);
    }
    (0, $bfc1bd9ef2af3f3a$export$f6cef6fcf9ca4e17)("\uD83D\uDCE1 \u4FE1\u53F7\u5DF2\u53D1\u9001 \u2014\u2014 \u5168\u57CE\u70DF\u82B1\u5DF2\u5C31\u7EEA", 3000);
}
function $2e4251c004ae6dfb$var$stop() {
    $2e4251c004ae6dfb$var$running = false;
    cancelAnimationFrame($2e4251c004ae6dfb$var$raf);
    clearTimeout($2e4251c004ae6dfb$var$stopTimer);
    $2e4251c004ae6dfb$var$stopTimer = null;
    if ($2e4251c004ae6dfb$var$onResize) window.removeEventListener("resize", $2e4251c004ae6dfb$var$onResize);
    $2e4251c004ae6dfb$var$onResize = null;
    if ($2e4251c004ae6dfb$var$canvas) {
        $2e4251c004ae6dfb$var$canvas.remove();
        $2e4251c004ae6dfb$var$canvas = null;
        $2e4251c004ae6dfb$var$ctx = null;
    }
}
function $2e4251c004ae6dfb$export$2e2bcd8739ae039() {
    const btn = document.getElementById("contact-signal");
    if (!btn) return;
    btn.addEventListener("click", (e)=>{
        e.preventDefault();
        $2e4251c004ae6dfb$var$launchFireworks();
    });
}


// 启动顺序：先渲染显现、再开机动画、后挂载交互
(0, $6f019d1f45ba2738$export$2e2bcd8739ae039)();
const $35da740d59af89ba$var$matrix = (0, $2a50b2c290a652fc$export$2e2bcd8739ae039)();
(0, $1585118342945ec6$export$2e2bcd8739ae039)();
(0, $97a50dd4078512d4$export$2e2bcd8739ae039)();
(0, $e39186f59ac2e9a5$export$2e2bcd8739ae039)();
(0, $19a012ebf879b934$export$2e2bcd8739ae039)();
(0, $946dd3a1a39b1629$export$2e2bcd8739ae039)();
(0, $dd00c3b72143464c$export$2e2bcd8739ae039)($35da740d59af89ba$var$matrix);
(0, $4d930d60ee20c2f7$export$2e2bcd8739ae039)($35da740d59af89ba$var$matrix);
(0, $b8855ed206bb3c2e$export$2e2bcd8739ae039)();
(0, $2e4251c004ae6dfb$export$2e2bcd8739ae039)();


//# sourceMappingURL=simplefolio.6bd80902.js.map
